import api from 'utils/api';

export interface StripeAccountInfo {
  open: boolean;
  accountId: string;
  linkUrl: string;
  chargeEnable: boolean;
  detailSubmitted: boolean;
}

const paymentService = {
  getStripeAccount: () => {
    return api.get<StripeAccountInfo>('/payments/stripe/account');
  },
  createStripeAccount: () => {
    return api.post<StripeAccountInfo>('/payments/stripe/account');
  },

  generateAccountLink: () => {
    return api.post<string>('/payments/stripe/account/generate-link');
  },
};

export default paymentService;
